var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm._t(
        "default",
        [
          _c(
            "div",
            { staticClass: "single page-content" },
            [
              _c("div", { staticClass: "container-max" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "d-flex row position-relative justify-content-between"
                  },
                  [
                    _c("div", { staticClass: "col-12 d-md-none d-sm-block" }, [
                      _c("div", { staticClass: "h2 title spc-sm-bt" }, [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm._f("itemName")(_vm.currentVariation)) +
                            "\n            "
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "item-artnr-strs spc-mdm-bt" }, [
                        _c("div", [
                          _c("span", { staticClass: "articlenumber small" }, [
                            _vm._v(
                              "\n                    " +
                                _vm._s(
                                  _vm.$translate(
                                    "Ceres::Template.singleItemNumber"
                                  )
                                ) +
                                "\n                  "
                            ),
                            _c("span", [
                              _vm._v(_vm._s(_vm.currentVariation.variation.id))
                            ])
                          ])
                        ]),
                        _vm._v(" "),
                        _c(
                          "a",
                          {
                            staticClass: "trust-star-row",
                            attrs: { href: "#feedback-section" }
                          },
                          _vm._l(5, function(n) {
                            return _c(
                              "div",
                              { staticClass: "trust-star" },
                              [
                                _vm.currentVariation.item.feedbackDecimal >= n
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "trust-star-form trust-star-fill"
                                      },
                                      [
                                        _c(
                                          "svg",
                                          {
                                            attrs: {
                                              xmlns:
                                                "http://www.w3.org/2000/svg",
                                              viewBox: "0 0 13 13"
                                            }
                                          },
                                          [
                                            _c("path", {
                                              attrs: {
                                                fill: "none",
                                                d:
                                                  "M6.826 10.743l-3.28 1.724a.5.5 0 0 1-.725-.528l.627-3.65a.5.5 0 0 0-.144-.443L.65 5.26a.5.5 0 0 1 .277-.853l3.666-.533a.5.5 0 0 0 .377-.273L6.61.279a.5.5 0 0 1 .896 0L9.147 3.6a.5.5 0 0 0 .376.273l3.666.533a.5.5 0 0 1 .277.853l-2.653 2.586a.5.5 0 0 0-.144.442l.627 3.651a.5.5 0 0 1-.726.528l-3.279-1.724a.5.5 0 0 0-.465 0z"
                                              }
                                            })
                                          ]
                                        )
                                      ]
                                    )
                                  : [
                                      _c(
                                        "div",
                                        { staticClass: "trust-star-form" },
                                        [
                                          _c(
                                            "svg",
                                            {
                                              attrs: {
                                                xmlns:
                                                  "http://www.w3.org/2000/svg",
                                                viewBox: "0 0 13 13"
                                              }
                                            },
                                            [
                                              _c("path", {
                                                attrs: {
                                                  fill: "none",
                                                  d:
                                                    "M6.826 10.743l-3.28 1.724a.5.5 0 0 1-.725-.528l.627-3.65a.5.5 0 0 0-.144-.443L.65 5.26a.5.5 0 0 1 .277-.853l3.666-.533a.5.5 0 0 0 .377-.273L6.61.279a.5.5 0 0 1 .896 0L9.147 3.6a.5.5 0 0 0 .376.273l3.666.533a.5.5 0 0 1 .277.853l-2.653 2.586a.5.5 0 0 0-.144.442l.627 3.651a.5.5 0 0 1-.726.528l-3.279-1.724a.5.5 0 0 0-.465 0z"
                                                }
                                              })
                                            ]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _vm.currentVariation.item
                                        .feedbackDecimal -
                                        n +
                                        1 >
                                      0
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "trust-star-form trust-star-last",
                                              style:
                                                "clip-path:inset(0px " +
                                                (100 -
                                                  (_vm.currentVariation.item
                                                    .feedbackDecimal -
                                                    n +
                                                    1) *
                                                    100) +
                                                "% 0px 0px)"
                                            },
                                            [
                                              _c(
                                                "svg",
                                                {
                                                  attrs: {
                                                    xmlns:
                                                      "http://www.w3.org/2000/svg",
                                                    viewBox: "0 0 13 13"
                                                  }
                                                },
                                                [
                                                  _c("path", {
                                                    attrs: {
                                                      fill: "none",
                                                      d:
                                                        "M6.826 10.743l-3.28 1.724a.5.5 0 0 1-.725-.528l.627-3.65a.5.5 0 0 0-.144-.443L.65 5.26a.5.5 0 0 1 .277-.853l3.666-.533a.5.5 0 0 0 .377-.273L6.61.279a.5.5 0 0 1 .896 0L9.147 3.6a.5.5 0 0 0 .376.273l3.666.533a.5.5 0 0 1 .277.853l-2.653 2.586a.5.5 0 0 0-.144.442l.627 3.651a.5.5 0 0 1-.726.528l-3.279-1.724a.5.5 0 0 0-.465 0z"
                                                    }
                                                  })
                                                ]
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    ]
                              ],
                              2
                            )
                          }),
                          0
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-12 col-md-7 col-xx-8 mx-wdth-lrg ml-auto mr-auto pl-0",
                        attrs: { id: "itemImageSection" }
                      },
                      [
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "stick-in-parent",
                                rawName: "v-stick-in-parent"
                              }
                            ]
                          },
                          [_vm._t("image-carousel")],
                          2
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "col-12 col-md-5 col-xx-4 pl-md-0 mt-spec"
                      },
                      [
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "stick-in-parent",
                                rawName: "v-stick-in-parent"
                              }
                            ]
                          },
                          [
                            _c("div", { staticClass: "d-md-block d-none" }, [
                              _c(
                                "h1",
                                {
                                  staticClass: "h2 title spc-sm-bt",
                                  attrs: { "data-testing": "item-name" }
                                },
                                [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(
                                        _vm._f("itemName")(_vm.currentVariation)
                                      ) +
                                      "\n                "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "item-artnr-strs spc-mdm-bt" },
                                [
                                  _c("div", [
                                    _c(
                                      "span",
                                      { staticClass: "articlenumber small" },
                                      [
                                        _vm._v(
                                          "\n                        " +
                                            _vm._s(
                                              _vm.$translate(
                                                "Ceres::Template.singleItemNumber"
                                              )
                                            ) +
                                            "\n                      "
                                        ),
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.currentVariation.variation.id
                                            )
                                          )
                                        ])
                                      ]
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _vm._t("star-rating-wrapper")
                                ],
                                2
                              )
                            ]),
                            _vm._v(" "),
                            _vm.$store.getters.currentItemVariation
                              .variationProperties &&
                            _vm.$store.getters.currentItemVariation
                              .variationProperties.length > 0
                              ? [
                                  _vm._l(
                                    _vm.$store.getters.currentItemVariation
                                      .variationProperties,
                                    function(variationPropertyGroups, index) {
                                      return [
                                        variationPropertyGroups.id == 16
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "d-lg-none d-md-block d-none showTechnicalData"
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticStyle: {
                                                      "margin-rigth": "4.5px"
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$translate(
                                                          "Ceres::Template.singleItemDescription"
                                                        )
                                                      )
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "svg",
                                                  {
                                                    attrs: {
                                                      xmlns:
                                                        "http://www.w3.org/2000/svg",
                                                      width: "10",
                                                      height: "6.069",
                                                      viewBox: "0 0 10 6.069"
                                                    }
                                                  },
                                                  [
                                                    _c("path", {
                                                      attrs: {
                                                        id:
                                                          "chevron-right-solid",
                                                        d:
                                                          "M33.4,43.046l-4.45,4.45a.55.55,0,0,1-.777,0l-.519-.519a.55.55,0,0,1,0-.776l3.527-3.544-3.527-3.544a.55.55,0,0,1,0-.776l.519-.519a.55.55,0,0,1,.777,0l4.45,4.45A.55.55,0,0,1,33.4,43.046Z",
                                                        transform:
                                                          "translate(47.657 -27.495) rotate(90)",
                                                        fill: "#464646"
                                                      }
                                                    })
                                                  ]
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        variationPropertyGroups.id == 16
                                          ? _c(
                                              "ul",
                                              {
                                                staticClass:
                                                  "TechnicalDataArea",
                                                attrs: {
                                                  id: "singleItemTechnicalData"
                                                }
                                              },
                                              [
                                                _vm._l(
                                                  variationPropertyGroups.properties,
                                                  function(
                                                    variationProperty,
                                                    index
                                                  ) {
                                                    return [
                                                      variationProperty.id ==
                                                        427 ||
                                                      variationProperty.id ==
                                                        428 ||
                                                      variationProperty.id ==
                                                        429 ||
                                                      variationProperty.id ==
                                                        430 ||
                                                      variationProperty.id ==
                                                        431
                                                        ? _c("li", {
                                                            domProps: {
                                                              innerHTML: _vm._s(
                                                                variationProperty
                                                                  .values.value
                                                              )
                                                            }
                                                          })
                                                        : _vm._e()
                                                    ]
                                                  }
                                                )
                                              ],
                                              2
                                            )
                                          : _vm._e()
                                      ]
                                    }
                                  )
                                ]
                              : _vm._e(),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-12 p-0" }, [
                              _c(
                                "a",
                                {
                                  staticClass:
                                    "gotoDescription d-lg-block d-md-none d-sm-block",
                                  attrs: { href: "#description-section" }
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticStyle: { "margin-rigth": "4.5px" }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$translate(
                                            "Ceres::Template.singleItemDescription"
                                          )
                                        )
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "svg",
                                    {
                                      attrs: {
                                        xmlns: "http://www.w3.org/2000/svg",
                                        width: "10",
                                        height: "6.069",
                                        viewBox: "0 0 10 6.069"
                                      }
                                    },
                                    [
                                      _c("path", {
                                        attrs: {
                                          id: "chevron-right-solid",
                                          d:
                                            "M33.4,43.046l-4.45,4.45a.55.55,0,0,1-.777,0l-.519-.519a.55.55,0,0,1,0-.776l3.527-3.544-3.527-3.544a.55.55,0,0,1,0-.776l.519-.519a.55.55,0,0,1,.777,0l4.45,4.45A.55.55,0,0,1,33.4,43.046Z",
                                          transform:
                                            "translate(47.657 -27.495) rotate(90)",
                                          fill: "#464646"
                                        }
                                      })
                                    ]
                                  )
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "etc-eek d-flex spc-mdm" },
                              [
                                _c(
                                  "div",
                                  { staticClass: "etc-eek-label" },
                                  [
                                    _vm.property194 &&
                                    _vm.property194.values &&
                                    _vm.property194.values.value
                                      ? _c(
                                          "a",
                                          {
                                            attrs: {
                                              href:
                                                _vm.property194.values.value,
                                              "data-lightbox":
                                                "single-item-image23"
                                            }
                                          },
                                          [
                                            _vm.property172 &&
                                            _vm.property172.values &&
                                            _vm.property172.values.description
                                              ? _c("lazy-img", {
                                                  attrs: {
                                                    "image-url":
                                                      _vm.property172.values
                                                        .description,
                                                    "picture-class": "lazyEek"
                                                  }
                                                })
                                              : _vm._e()
                                          ],
                                          1
                                        )
                                      : _vm.property172 &&
                                        _vm.property172.values &&
                                        _vm.property172.values.description
                                      ? _c("lazy-img", {
                                          attrs: {
                                            "image-url":
                                              _vm.property172.values
                                                .description,
                                            "picture-class": "lazyEek"
                                          }
                                        })
                                      : _vm._e()
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _vm.property209 &&
                                _vm.property209.values &&
                                _vm.property209.values.value
                                  ? _c("pdf-viewer", {
                                      attrs: {
                                        pdfUrl: _vm.property209.values.value
                                      }
                                    })
                                  : _vm._e()
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _vm.attributes.length
                              ? _c(
                                  "div",
                                  { class: "spc-mdm" },
                                  [_c("variation-select")],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c("item-price", {
                              attrs: {
                                "show-cross-price": _vm.isRecommendedPriceActive
                              }
                            }),
                            _vm._v(" "),
                            _vm._t("after-price"),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "col-12 d-flex p-0 mt-1 space-between h-lg-50"
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "openShippingCostsWrapper btn col-4 bg-lightgrey flex-auto d-flex justify-content-center align-items-center ModalInformationCard",
                                    on: {
                                      click: function($event) {
                                        return _vm.showModal("shipping")
                                      }
                                    }
                                  },
                                  [
                                    _c("span", {
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.$translate(
                                            "ETCeresCoconut::Template.singleItemShippingCostsInformation"
                                          )
                                        )
                                      }
                                    })
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "btn openNewsletterWrapper col-4 bg-lightgrey mr-1 ml-1 flex-auto d-flex justify-content-center align-items-center ModalInformationCard",
                                    on: {
                                      click: function($event) {
                                        $event.preventDefault()
                                        return _vm.$root.$emit(
                                          "open-newsletter-modal"
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _c("span", {
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.$translate(
                                            "ETCeresCoconut::Template.singleItemNewsletterInformation"
                                          )
                                        )
                                      }
                                    })
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "btn col-4 bg-lightgrey flex-auto d-flex justify-content-center align-items-center ModalInformationCard",
                                    attrs: { id: "openPaymentsWrapper" },
                                    on: {
                                      click: function($event) {
                                        return _vm.showModal("payment")
                                      }
                                    }
                                  },
                                  [
                                    _c("span", {
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.$translate(
                                            "ETCeresCoconut::Template.singleItemPaymentsInformation"
                                          )
                                        )
                                      }
                                    })
                                  ]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "spc-mdm availability" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "half-circle p-0 m-0",
                                  class:
                                    "availability-" +
                                    _vm.currentVariation.variation.availability
                                      .id
                                },
                                [
                                  _c(
                                    "svg",
                                    {
                                      attrs: {
                                        xmlns: "http://www.w3.org/2000/svg",
                                        width: "15",
                                        height: "15",
                                        viewBox: "0 0 15 15"
                                      }
                                    },
                                    [
                                      _c("path", {
                                        attrs: {
                                          id: "circle-check-solid",
                                          d:
                                            "M7.5,15A7.5,7.5,0,1,0,0,7.5,7.5,7.5,0,0,0,7.5,15Zm3.311-8.877-3.75,3.75a.7.7,0,0,1-.993,0L4.192,8A.7.7,0,0,1,5.186,7L6.563,8.382,9.814,5.127a.7.7,0,1,1,.993.993Z",
                                          fill: "#fff"
                                        }
                                      })
                                    ]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "availability-name",
                                  class:
                                    "availability-" +
                                    _vm.currentVariation.variation.availability
                                      .id
                                },
                                [
                                  _vm.currentVariation.variation.availability
                                    .id == 1
                                    ? [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$translate(
                                              "ETCeresCoconut::Template.singleItemAvailability1"
                                            )
                                          )
                                        )
                                      ]
                                    : _vm.currentVariation.variation
                                        .availability.id == 2
                                    ? [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$translate(
                                              "ETCeresCoconut::Template.singleItemAvailability2"
                                            )
                                          )
                                        )
                                      ]
                                    : _vm.currentVariation.variation
                                        .availability.id == 3
                                    ? [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$translate(
                                              "ETCeresCoconut::Template.singleItemAvailability3"
                                            )
                                          )
                                        )
                                      ]
                                    : _vm.currentVariation.variation
                                        .availability.id == 4
                                    ? [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$translate(
                                              "ETCeresCoconut::Template.singleItemAvailability4"
                                            )
                                          )
                                        )
                                      ]
                                    : _vm.currentVariation.variation
                                        .availability.id == 5
                                    ? [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$translate(
                                              "ETCeresCoconut::Template.singleItemAvailability5"
                                            )
                                          )
                                        )
                                      ]
                                    : _vm.currentVariation.variation
                                        .availability.id == 6
                                    ? [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$translate(
                                              "ETCeresCoconut::Template.singleItemAvailability6"
                                            )
                                          )
                                        )
                                      ]
                                    : _vm.currentVariation.variation
                                        .availability.id == 7
                                    ? [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$translate(
                                              "ETCeresCoconut::Template.singleItemAvailability7"
                                            )
                                          )
                                        )
                                      ]
                                    : _vm.currentVariation.variation
                                        .availability.id == 8
                                    ? [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$translate(
                                              "ETCeresCoconut::Template.singleItemAvailability8"
                                            )
                                          )
                                        )
                                      ]
                                    : _vm.currentVariation.variation
                                        .availability.id == 9
                                    ? [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$translate(
                                              "ETCeresCoconut::Template.singleItemAvailability9"
                                            )
                                          )
                                        )
                                      ]
                                    : [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$translate(
                                              "ETCeresCoconut::Template.singleItemAvailability10"
                                            )
                                          )
                                        )
                                      ]
                                ],
                                2
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "spc-mdm" }, [
                              _c(
                                "div",
                                { staticClass: "w-100" },
                                [_vm._t("before-add-to-basket")],
                                2
                              ),
                              _vm._v(" "),
                              _vm.currentVariation.item.itemType === "set"
                                ? _c(
                                    "div",
                                    { staticClass: "alert alert-info w-100" },
                                    [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(
                                            _vm.$translate(
                                              "Ceres::Template.singleItemSetInfo"
                                            )
                                          ) +
                                          "\n                "
                                      )
                                    ]
                                  )
                                : _c(
                                    "div",
                                    {
                                      staticClass:
                                        "col-12 col-sm-12 col-md-12 col-lg-12 my-3 p-0 d-flex",
                                      staticStyle: { "align-items": "baseline" }
                                    },
                                    [
                                      _c("add-to-wish-list", {
                                        staticClass: "singleItemAddToWishlist",
                                        attrs: {
                                          "variation-id":
                                            _vm.currentVariation.variation.id
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("add-to-basket", {
                                        staticClass: "w-100 btn-width-unset",
                                        attrs: {
                                          "variation-id":
                                            _vm.currentVariation.variation.id,
                                          "is-salable":
                                            !!_vm.currentVariation.filter &&
                                            _vm.currentVariation.filter
                                              .isSalable,
                                          "has-children":
                                            !!_vm.currentVariation.filter &&
                                            _vm.currentVariation.filter
                                              .hasActiveChildren,
                                          "interval-quantity":
                                            _vm.currentVariation.variation
                                              .intervalOrderQuantity || 1,
                                          "minimum-quantity":
                                            _vm.currentVariation.variation
                                              .minimumOrderQuantity,
                                          "maximum-quantity":
                                            !!_vm.currentVariation.variation
                                              .maximumOrderQuantity &&
                                            _vm.currentVariation.variation
                                              .maximumOrderQuantity > 0
                                              ? _vm.currentVariation.variation
                                                  .maximumOrderQuantity
                                              : null,
                                          "order-properties": _vm.currentVariation.properties.filter(
                                            function(prop) {
                                              return prop.property
                                                .isOderProperty
                                            }
                                          ),
                                          "use-large-scale": false,
                                          "show-quantity": true,
                                          "item-url": _vm._f("itemURL")(
                                            _vm.currentVariation
                                          ),
                                          "is-variation-selected":
                                            _vm.isVariationSelected &&
                                            _vm.currentVariation.filter
                                              .isSalable,
                                          "has-price": _vm._f(
                                            "hasItemDefaultPrice"
                                          )(_vm.currentVariation)
                                        }
                                      })
                                    ],
                                    1
                                  ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "w-100" },
                                [_vm._t("after-add-to-basket")],
                                2
                              )
                            ]),
                            _vm._v(" "),
                            _vm._t("trust-badge"),
                            _vm._v(" "),
                            _c("hr", {
                              staticStyle: {
                                "margin-top": "30px",
                                "margin-bottom": "20px"
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "spc-lrg-tp d-flex row artikel-entsorgungshinweis font-12"
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "d-flex geraeteruecknahme" },
                                  [
                                    _vm.currentVariation.filter.isSalable &&
                                    _vm.variationGroupedProperties.length
                                      ? [_c("order-property-list")]
                                      : _vm._e()
                                  ],
                                  2
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "d-flex artikel-entsorgungshinweis-link"
                                  },
                                  [
                                    _c(
                                      "a",
                                      {
                                        staticClass:
                                          "openEntsorgungshinweisWrapper btn font-12 p-0",
                                        on: {
                                          click: function($event) {
                                            return _vm.showModal("disposal")
                                          }
                                        }
                                      },
                                      [
                                        _c(
                                          "svg",
                                          {
                                            attrs: {
                                              xmlns:
                                                "http://www.w3.org/2000/svg",
                                              width: "15.335",
                                              height: "15",
                                              viewBox: "0 0 15.335 15"
                                            }
                                          },
                                          [
                                            _c("path", {
                                              attrs: {
                                                id: "recycle-solid",
                                                d:
                                                  "M5.4,7.293a.718.718,0,0,1-1.081.77l-.728-.455L2.07,10.047a.959.959,0,0,0,.813,1.467h.959a.959.959,0,0,1,0,1.917H2.886a2.876,2.876,0,0,1-2.44-4.4L1.969,6.6l-.73-.458a.72.72,0,0,1,.22-1.312L4.2,4.192a.485.485,0,0,1,.578.361ZM8.486,2.377,9.721,4.358,9,4.81a.719.719,0,0,0,.218,1.311l2.738.633a.479.479,0,0,0,.575-.36l.63-2.739a.719.719,0,0,0-1.08-.772l-.73.455L10.112,1.364a2.876,2.876,0,0,0-4.876,0l-.222.354A.958.958,0,0,0,6.638,2.733l.223-.356A.959.959,0,0,1,8.486,2.377ZM14.9,9.036l-.509-.816a.957.957,0,1,0-1.624,1.014l.509.813a.959.959,0,0,1-.813,1.468H9.59v-.861a.719.719,0,0,0-1.227-.508l-1.989,1.99a.481.481,0,0,0,0,.678L8.364,14.8a.719.719,0,0,0,1.227-.509v-.859h2.871A2.875,2.875,0,0,0,14.9,9.036Z",
                                                transform:
                                                  "translate(-0.007 -0.012)"
                                              }
                                            })
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$translate(
                                                "ETCeresCoconut::Template.footerInformationSectionEntsorgungshinweiseText"
                                              )
                                            )
                                          )
                                        ])
                                      ]
                                    )
                                  ]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _vm._t("additional-content-after-add-to-basket")
                          ],
                          2
                        )
                      ]
                    )
                  ]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "tab-section" }, [
                _c("div", { staticClass: "container-max max-1330" }, [
                  _c("div", { staticClass: "my-3" }, [
                    _c(
                      "ul",
                      {
                        staticClass: "nav nav-tabs",
                        attrs: { role: "tablist" }
                      },
                      [
                        _vm.isDescriptionTabActive
                          ? _c("li", { staticClass: "nav-item" }, [
                              _c(
                                "a",
                                {
                                  staticClass: "nav-link active",
                                  attrs: {
                                    id: "description-section",
                                    "data-toggle": "tab",
                                    href:
                                      "#details-" +
                                      _vm.currentVariation.variation.id,
                                    role: "tab"
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$translate(
                                        "Ceres::Template.singleItemDescription"
                                      )
                                    )
                                  )
                                ]
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.isEuResponsibleTabShown && _vm.showResponsible
                          ? _c("li", { staticClass: "nav-item" }, [
                              _c(
                                "a",
                                {
                                  staticClass: "nav-link",
                                  attrs: {
                                    "data-toggle": "tab",
                                    href: "#eu-responsible",
                                    role: "tab"
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$translate(
                                        "Ceres::Template.singleItemEuResponsiblePerson"
                                      )
                                    )
                                  )
                                ]
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.isManufacturerTabShown && _vm.showManufacturer
                          ? _c("li", { staticClass: "nav-item" }, [
                              _c(
                                "a",
                                {
                                  staticClass: "nav-link",
                                  attrs: {
                                    "data-toggle": "tab",
                                    href: "#manufacturer",
                                    role: "tab"
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$translate(
                                        "Ceres::Template.singleItemManufacturer"
                                      )
                                    )
                                  )
                                ]
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm._t("add-detail-tabs")
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "tab-content overflow-hidden" },
                      [
                        _vm.isDescriptionTabActive
                          ? _c(
                              "div",
                              {
                                staticClass: "tab-pane active overflow-auto",
                                attrs: {
                                  id:
                                    "details-" +
                                    _vm.currentVariation.variation.id,
                                  role: "tabpanel"
                                }
                              },
                              [
                                _c("div", {
                                  staticClass: "my-4",
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.currentVariation.texts.description
                                    )
                                  }
                                })
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.isEuResponsibleTabShown && _vm.showResponsible
                          ? _c(
                              "div",
                              {
                                staticClass: "tab-pane overflow-auto",
                                attrs: {
                                  id: "eu-responsible",
                                  role: "tabpanel"
                                }
                              },
                              [
                                _c("div", { staticClass: "my-4" }, [
                                  _c("div", { staticClass: "p-0" }, [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.currentVariation.item.manufacturer
                                            .responsibleName
                                        )
                                      )
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "p-0" }, [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.currentVariation.item.manufacturer
                                            .responsibleStreet
                                        )
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.currentVariation.item.manufacturer
                                            .responsibleHouseNo
                                        )
                                      )
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "p-0" }, [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.currentVariation.item.manufacturer
                                            .responsiblePostCode
                                        )
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.currentVariation.item.manufacturer
                                            .responsibleTown
                                        )
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _vm.currentVariation.item.manufacturer
                                      .responsibleCountryObject
                                      ? _c("span", [
                                          _vm._v(
                                            "\n                     " +
                                              _vm._s(
                                                _vm.currentVariation.item
                                                  .manufacturer
                                                  .responsibleCountryObject.name
                                              ) +
                                              "\n                    "
                                          )
                                        ])
                                      : _vm._e()
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "p-0" }, [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.currentVariation.item.manufacturer
                                            .responsibleEmail
                                        )
                                      )
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "p-0" }, [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.currentVariation.item.manufacturer
                                            .responsiblePhoneNo
                                        )
                                      )
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "p-0" }, [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.currentVariation.item.manufacturer
                                            .responsibleContactUrl
                                        )
                                      )
                                    ])
                                  ])
                                ])
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.isManufacturerTabShown && _vm.showManufacturer
                          ? _c(
                              "div",
                              {
                                staticClass: "tab-pane overflow-auto",
                                attrs: { id: "manufacturer", role: "tabpanel" }
                              },
                              [
                                _c("div", { staticClass: "my-4" }, [
                                  _c("div", { staticClass: "p-0" }, [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.currentVariation.item.manufacturer
                                            .name
                                        )
                                      )
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "p-0" }, [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.currentVariation.item.manufacturer
                                            .legalName
                                        )
                                      )
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "p-0" }, [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.currentVariation.item.manufacturer
                                            .street
                                        )
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.currentVariation.item.manufacturer
                                            .houseNo
                                        )
                                      )
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "p-0" }, [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.currentVariation.item.manufacturer
                                            .postcode
                                        )
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.currentVariation.item.manufacturer
                                            .town
                                        )
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _vm.currentVariation.item.manufacturer
                                      .countryObject
                                      ? _c("span", [
                                          _vm._v(
                                            "\n                                    " +
                                              _vm._s(
                                                _vm.currentVariation.item
                                                  .manufacturer.countryObject
                                                  .name
                                              ) +
                                              "\n                                  "
                                          )
                                        ])
                                      : _vm._e()
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "p-0" }, [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.currentVariation.item.manufacturer
                                            .email
                                        )
                                      )
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "p-0" }, [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.currentVariation.item.manufacturer
                                            .url
                                        )
                                      )
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "p-0" }, [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.currentVariation.item.manufacturer
                                            .phoneNumber
                                        )
                                      )
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "p-0" }, [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.currentVariation.item.manufacturer
                                            .faxNumber
                                        )
                                      )
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "p-0" }, [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.currentVariation.item.manufacturer
                                            .contactUrl
                                        )
                                      )
                                    ])
                                  ])
                                ])
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm._t("add-detail-tabs-content")
                      ],
                      2
                    )
                  ])
                ])
              ]),
              _vm._v(" "),
              _vm._t("cross-selling-similar"),
              _vm._v(" "),
              _vm._t("cross-selling-accessory"),
              _vm._v(" "),
              _c("lazy-content-modal", {
                attrs: {
                  visible: _vm.modalType === "shipping",
                  "category-id": _vm.shippingCategoryId,
                  title: _vm.$translate(
                    "ETCeresCoconut::Template.footerInformationSectionVersandText"
                  )
                },
                on: {
                  close: function($event) {
                    _vm.modalType = null
                  }
                }
              }),
              _vm._v(" "),
              _c("lazy-content-modal", {
                attrs: {
                  visible: _vm.modalType === "payment",
                  "category-id": _vm.paymentCategoryId,
                  title: _vm.$translate(
                    "ETCeresCoconut::Template.footerInformationSectionZahlungText"
                  )
                },
                on: {
                  close: function($event) {
                    _vm.modalType = null
                  }
                }
              }),
              _vm._v(" "),
              _c("lazy-content-modal", {
                attrs: {
                  visible: _vm.modalType === "disposal",
                  "category-id": _vm.disposalCategoryId,
                  title: _vm.$translate(
                    "ETCeresCoconut::Template.footerInformationSectionEntsorgungshinweiseText"
                  )
                },
                on: {
                  close: function($event) {
                    _vm.modalType = null
                  }
                }
              }),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "container-max max-1330",
                  attrs: { id: "feedback-section" }
                },
                [_vm._t("default-dropzone")],
                2
              ),
              _vm._v(" "),
              _vm._t("feedback-container"),
              _vm._v(" "),
              _vm._t("item-list-container")
            ],
            2
          )
        ],
        {
          getDataField: _vm.getDataField,
          getFilteredDataField: _vm.getFilteredDataField
        }
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }